real.events = (function (real) {
    'use strict';

    const handlers = {};
    let eventsStack = [];

    const logDuplicateEventError = event => {
        const errorMessage = 'Websocket :: Duplicate event error';
        const errorUrl = real.cdnUri + '/assets/js/real/events.js';
        const errorLineNumber = 1;
        const errorColumnNumber = 1;

        const error = new Error(errorMessage);

        error.stack = ''
            + 'Websocket :: the event with id "' + event.id + '" was already received and handled. Something is wrong.\n\n'
            + 'Duplicate event:\n'
            + JSON.stringify(event, null, 2) + '\n\n'
            + 'The real.realtime.getTopics() says the client is connected to the following topics:\n'
            + real.realtime.getTopics().join('\n') + '\n\n'
            + real.errorlogger.cleanErrorStack(error.stack)
        ;

        real.errorlogger.sendErrorToServer(errorMessage, errorUrl, errorLineNumber, errorColumnNumber, error);
    };

    return {

        CSS_UPDATED: 'css.updated',
        REALTIME_RECONNECTED: 'realtime.reconnected',

        on: (action, fn) => {
            if (!handlers[action]) {
                handlers[action] = [];
            }
            handlers[action].push(fn);
        },

        off: (action, fn) => {
            if (!handlers[action]) {
                return;
            }
            handlers[action].forEach(function (loopFn, i) {
                if (loopFn === fn) {
                    handlers[action].splice(i, 1);
                    return;
                }
            });
        },

        trigger: (action, notification) => {
            if (!handlers[action]) {
                // No handlers assigned for action
                return;
            }

            handlers[action].forEach(function (fn) {
                fn(notification);
            });
        },

        triggerServerEvents: events => {
            let foundDuplicateEvent = false;

            events.forEach(function (event) {
                if (typeof event === 'string') {
                    event = JSON.parse(event);
                }

                eventsStack.forEach(function (stackEvent) {
                    if (stackEvent.id === event.id) {
                        // Oh noes, a duplicate event. Either client has subscribed to same topic twice
                        // or then there might be some error in server side. Log an error and do
                        // not handle this duplicate event any further.
                        foundDuplicateEvent = true;
                        logDuplicateEventError(event);
                    }
                });

                if (foundDuplicateEvent === true) {
                    console.log('Websocket :: Duplicate event was triggered, stopping execution here');
                    return;
                }

                eventsStack.push(event);
                eventsStack = eventsStack.slice(0, 20);

                real.events.trigger(
                    event.message.notification.action,
                    event.message.notification
                );
            });
        },

        getLatestEvents: () => {
            return eventsStack;
        },

        isFromCurrentUser: notification => {
            return notification?.actor?.user?.id === real.dom.$body.data('user-id');
        },

        isFromCurrentWindow: notification => {
            return notification?.actor?.window?.id === real.dom.$html.data('window-id');
        }

    };

})(real);
